module.exports = __webpack_public_path__ + "app/assets/images/woman9-9fea64b386a48606c7d1abbe1eb68418.jpg";